import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = {
  for: "email",
  class: "form-label"
}
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = { class: "form-error-text" }
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = {
  for: "password",
  class: "form-label"
}
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "form-error-text" }
const _hoisted_9 = { class: "mb-4" }
const _hoisted_10 = {
  for: "password_confirmation",
  class: "form-label"
}
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = { class: "form-error-text" }
const _hoisted_13 = { class: "flex items-center justify-between pt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_form_submit = _resolveComponent("base-form-submit")!
  const _component_base_shadow_card = _resolveComponent("base-shadow-card")!
  const _component_layouts_guest = _resolveComponent("layouts-guest")!

  return (_openBlock(), _createBlock(_component_layouts_guest, null, {
    default: _withCtx(() => [
      _createVNode(_component_base_shadow_card, {
        title: _ctx.t('reset_password.title')
      }, {
        default: _withCtx(() => [
          _createElementVNode("form", {
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.t('word.email')), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                id: "email",
                name: "email",
                type: "email",
                placeholder: _ctx.t('word.email'),
                class: _normalizeClass(`form-input ${_ctx.errors['email'] ? '!border-red-500' : ''}`)
              }, null, 10, _hoisted_3), [
                [_vModelText, _ctx.email]
              ]),
              _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.errors['email']), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.t('word.password_new')), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                id: "password",
                name: "password",
                type: "password",
                placeholder: _ctx.t('word.password_new'),
                class: _normalizeClass(`form-input ${_ctx.errors['password'] ? '!border-red-500' : ''}`)
              }, null, 10, _hoisted_7), [
                [_vModelText, _ctx.password]
              ]),
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.errors['password']), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.t('word.password_confirmation')), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password_confirmation) = $event)),
                id: "password_confirmation",
                name: "password_confirmation",
                type: "password",
                placeholder: _ctx.t('word.password_confirmation'),
                class: _normalizeClass(`form-input ${_ctx.errors['password_confirmation'] ? '!border-red-500' : ''}`)
              }, null, 10, _hoisted_11), [
                [_vModelText, _ctx.password_confirmation]
              ]),
              _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.errors['password_confirmation']), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.router.back())),
                type: "button",
                class: "bg-gray-300 hover:bg-gray-400 text-gray-800 py-1.5 px-4 rounded"
              }, _toDisplayString(_ctx.t('word.back')), 1),
              _createVNode(_component_base_form_submit, { disabled: _ctx.btnDisabled }, null, 8, ["disabled"])
            ])
          ], 32)
        ]),
        _: 1
      }, 8, ["title"])
    ]),
    _: 1
  }))
}